import { FCI_ERROR } from "@searchui-searchforms/shared/fci";
import { fciFetch } from "@/shared/lib/fci";
import type { SearchPreferencesRead } from "./types";

export const getUserPreferences = (useDirectSearchPreferences: boolean) =>
    fciFetch<SearchPreferencesRead>(
        useDirectSearchPreferences ? "/api/searchforms/search-preferences" : "/api/search-preferences",
        {
            fci: {
                // Fetches saved user preferences (exactness, filters, etc.)
                // If it fails, the form falls back to defaults
                errorType: FCI_ERROR.Convenience,
                errorInfo: "getUserPreferences",
            },
        },
    );
